import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TagComponent, TagVariant } from '@catch/general-ui';
import { TooltipDirective } from '@catch/directives';
import { ToastsService } from '@catch/services';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faEnvelope,
  faThumbsDown,
  faSort,
  faSortDown,
  faSortUp,
  faTrash,
  faUser,
} from '@fortawesome/pro-light-svg-icons';
import { TranslocoPipe } from '@jsverse/transloco';
import { TableModule } from 'primeng/table';
import { PlatformJobApplyMenuComponent } from '../../../../components/job-apply-menu/platform-job-apply-menu.component';
import { PlatformCompanyLogoComponent } from '../../../../components/company-logo/platform-company-logo.component';
import { PlatformInvitation } from '../../../../models/platform.models';
import { PlatformJobsService } from '../../../../services/platform-jobs.service';
import { PlatformJobsEmptyStateComponent } from '../jobs-empty-state/platform-jobs-empty-state.component';

@Component({
  selector: 'app-platform-jobs-invitations',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DatePipe,
    TagComponent,
    FontAwesomeModule,
    TooltipDirective,
    TranslocoPipe,
    TableModule,
    PlatformCompanyLogoComponent,
    PlatformJobApplyMenuComponent,
    PlatformJobsEmptyStateComponent,
  ],
  templateUrl: './platform-jobs-invitations.component.html',
  styleUrl: './platform-jobs-invitations.component.scss',
})
export class PlatformJobsInvitationsComponent {
  readonly jobs = inject(PlatformJobsService);
  private readonly toastsService = inject(ToastsService);

  readonly TagVariant = TagVariant;
  readonly icons = {
    envelope: faEnvelope,
    user: faUser,
    decline: faThumbsDown,
    trash: faTrash,
    sort: faSort,
    sortUp: faSortUp,
    sortDown: faSortDown,
  };

  /**
   * Tracks table rows by invitation id.
   * @param _index - Row index
   * @param invitation - Invitation row
   * @returns Stable row id
   */
  trackById(_index: number, invitation: PlatformInvitation): number {
    return invitation.id;
  }

  /**
   * Declines the invitation and hides the job from future suggestions.
   * @param invitation - Invitation to decline
   */
  decline(invitation: PlatformInvitation): void {
    this.jobs.declineInvitation(invitation.id);
    this.toastsService.info('jobboard.platform.jobs.invitations.decline-toast');
  }

  /**
   * Removes a closed invitation from the list.
   * @param invitation - Invitation to remove
   */
  remove(invitation: PlatformInvitation): void {
    this.jobs.removeInvitation(invitation.id);
    this.toastsService.info('jobboard.platform.jobs.invitations.removed-toast');
  }
}
